<template>
	<el-container class="app-wrapper">
		<!-- 顶部导航 -->
		<el-header height="60px" class="app-header">
			<div class="header-left">
				<div class="logo" @click="_toIndex">
					<!-- {{ systemInfo.systemSimpleTitle }} -->
					<!-- 智慧空间资产运营系统 -->
					<img src="/img/logo_1.png" alt="logo" class="logo-img" />
				</div>
				<el-menu
					mode="horizontal"
					:default-active="activeMenu"
					class="header-menu"
					background-color="transparent"
					text-color="#1C1C1C"
					active-text-color="#fff">
					<template v-for="(item, index) in catalogs">
						<el-menu-item
							:index="item.caId"
							v-if="!item.privId || hasPrivilege(item.privId)"
							:key="index"
							@click="_changeMenuCatalog(item, true)">
							<div class="header-menu-item" :class="activeMenu === item.caId && 'header-menu-item-active'">
								<i class="fa header-menu-item-icon" v-bind:class="item.icon"></i>
								<div>{{ item.name }}</div>
							</div>
						</el-menu-item>
					</template>
				</el-menu>
			</div>
			<div class="header-right">
				<el-dropdown @command="changeCommunity" v-if="storeInfo.storeTypeCd == '800900000003'" class="margin-right">
					<span class="user-info">
						{{ curCommunityName }}
						<i class="el-icon-arrow-down el-icon--right"></i>
					</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item :command="c" v-for="(c, index) in communitys" :key="index">{{ c.name }}</el-dropdown-item>
						<el-dropdown-item command="moreCommunity" class="moreCommunity">
							{{ $t('layout.moreCommunity') }}
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<!-- <el-dropdown @command="handleCommand">
					<span class="user-info">
						{{ username }}
						<i class="el-icon-arrow-down el-icon--right"></i>
					</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command="logout">{{ $t('layout.logout') }}</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown> -->
				<!-- <span class="margin-left">{{ systemInfo.version }}</span> -->
				<span class="user-info">{{ username }}</span>
				<div class="icons">
					<i class="fa fa-bell-o i"></i>
				</div>
				<div class="icons">
					<i class="fa fa-sign-out" @click="handleCommand('logout')"></i>
				</div>
			</div>
		</el-header>

		<el-container>
			<!-- 左侧菜单 width="64px"-->
			<el-aside class="app-aside" width="159">
				<el-menu
					class="vc-menu-main"
					:default-active="activeAsideMenu"
					background-color="transparent"
					text-color="#1C1C1C"
					unique-opened
					active-text-color="#1C1C1C"
					@select="handerSelect">
					<!-- <el-menu-item index="0">
						<div class="home-menu menu-items" :class="activeAsideMenu === '0' && 'menu-items-active'">
							<i class="fa fa-pie-chart" style="color: #1c1c1c"></i>
							<span class="menu-title">数据统计</span>
						</div>
					</el-menu-item> -->
					<!-- <div class="menu-group">业务受理</div> -->
					<template v-for="menu in menuTree">
						<el-menu-item v-if="!menu.childs || menu.childs.length == 0" :key="menu.id" :index="menu.id">
							<div class="menu-items">
								<i class="fa" v-bind:class="menu.icon" style="color: #1c1c1c"></i>
								<span class="menu-title">{{ menu.name }}</span>
							</div>
						</el-menu-item>
						<el-submenu v-if="menu.childs && menu.childs.length > 0" :index="menu.id" :key="menu.id">
							<template slot="title">
								<div class="menu-items" style="padding-left: 0px">
									<i class="fa" v-bind:class="menu.icon" style="color: #1c1c1c"></i>
									<span class="menu-title">{{ menu.name }}</span>
								</div>
							</template>
							<!-- {{ menu.name }} -->
							<template v-for="subMenu in menu.childs">
								<el-menu-item v-if="subMenu.isShow === 'Y'" :key="subMenu.mId" :index="subMenu.mId">
									<div
										class="menu-items"
										style="width: 159px"
										:class="activeAsideMenu === subMenu.mId && 'menu-items-active'">
										{{ subMenu.name }}
									</div>
								</el-menu-item>
							</template>
						</el-submenu>
					</template>
				</el-menu>
				<!-- <div class="vc-menu flex justify-start" id="menu-nav">
					<div class="vc-menu-main">
						<ul>
							<template v-for="(menu, index) in menuTree">
								<li
									:key="index"
									v-if="menu.childs && menu.childs.length > 0"
									:class="{ active: menu.active }"
									@click="switchMenu(menu)">
									<i class="fa" v-bind:class="menu.icon"></i>
									<span class="margin-left-xs">{{ menu.name }}</span>
								</li>
							</template>
						</ul>
					</div>
					<div class="vc-menu-sub" v-if="subMenus && subMenus.length > 0">
						<ul>
							<li class="title">{{ curMenuName }}</li>
							<template v-for="(subMenu, index) in subMenus">
								<li
									:key="index"
									v-if="subMenu.isShow == 'Y'"
									:class="{ active: subMenu.active }"
									v-on:click="_gotoPage(subMenu.href, subMenu.name)">
									{{ subMenu.name }}
								</li>
							</template>
							<li class="sub-footer" @click="_closeSubMenu()"><i class="fa fa-dedent"></i></li>
						</ul>
					</div>
				</div> -->
			</el-aside>

			<!-- 主要内容区 -->
			<el-main class="app-main">
				<!-- 多标签页：单行不换行 -->
				<div class="tabs-wrap" v-if="visitedTabs.length > 0">
					<div class="tabs-list">
						<div
							v-for="tab in visitedTabs"
							:key="tab.path"
							:class="['tabs-item', { active: $route.path === tab.path }]"
							@click="goTab(tab)">
							<span class="tabs-item-title">{{ tab.titleKey ? $t(tab.titleKey) : tab.title }}</span>
							<i class="el-icon-close tabs-item-close" @click.stop="removeTab(tab)" v-if="visitedTabs.length > 1"></i>
						</div>
					</div>
					<el-button type="text" size="mini" class="tabs-close-all" @click="closeAllTabs">
						{{ $t('layout.closeAllTabs') }}
					</el-button>
				</div>
				<router-view />
			</el-main>
		</el-container>
		<more-community ref="moreCommunity" />
		<view-menu-user-list ref="viewMenuUserModel" />
		<search-community-data-list ref="searchCommunityDataModel" />
	</el-container>
</template>

<script>
	import { _getMenuCatalog, getMenuTree, jumpToMall, jumpToIot } from '@/api/user/menuApi';
	import { getStoreInfo } from '@/api/user/indexApi';
	import { listSystemInfo } from '@/api/system/systemInfoManageApi';
	import { deepCopy, setCurrentCommunity, getCurrentCommunity } from '@/utils/vc';
	import { getCommunityName, _loadCommunityInfo } from '@/api/community/communityApi';
	import moreCommunity from '@/components/community/moreCommunity.vue';
	import viewMenuUserList from '@/components/system/viewMenuUserList.vue';
	import searchCommunityDataList from '@/components/system/searchCommunityDataList.vue';
	import { initSystem } from '@/api/util/vcApi';
	import config from '@/conf/config';
	import store from '@/store';

	export default {
		name: 'Layout',
		data() {
			return {
				catalogs: [],
				menuTree: [],
				subMenus: [],
				menuWidth: 80,
				menuId: '',
				curMenuName: '',
				activeMenu: '',
				activeAsideMenu: '0',
				activeSubMenu: 'communityList',
				searchText: '',
				username: '',
				curCommunityName: '',
				communitys: [],
				storeInfo: {
					storeTypeCd: '',
					storeId: '',
				},
				systemInfo: {
					systemSimpleTitle: '',
					companyName: '',
					logoUrl: '',
					version: '',
				},
				visitedTabs: [], // 已打开的页面 { path, titleKey?, title? }
			};
		},
		watch: {
			$route: {
				handler(route) {
					if (!route.path || route.path === '/views/user/login' || route.path === '/login') return;
					const path = route.path;
					const exists = this.visitedTabs.some(t => t.path === path);

					if (!exists) {
						const info = this.getTabTitle(path, route.meta || {});
						if (info) this.visitedTabs.push({ path, ...info });
					}

					const routeItem = this.findChildByPath(this.menuTree, path);

					if (routeItem) {
						this.activeAsideMenu = routeItem.mId;
					}
				},
				immediate: true,
			},
		},
		async created() {
			let _user = JSON.parse(localStorage.getItem('user'));
			this.username = _user.name;
			this.systemInfo.version = config.version;
			this.getSystemInfo();
			this._loadStoreInfo();
			this.loadCatalogs();
			this.curCommunityName = getCommunityName();
			this.loadCommunity();
			initSystem();
			await store.dispatch('enumStore/initMenu');
		},
		components: {
			moreCommunity,
			viewMenuUserList,
			searchCommunityDataList,
		},
		methods: {
			handerSelect(val) {
				this.activeAsideMenu = val;
				if (val === '0') {
					this.$router.push('/views/index/index').catch(() => {});
					return;
				}
				const item = this.findChildById(this.menuTree, val);
				this._gotoPage(item.href, item.name);
			},
			findChildById(list, targetId) {
				for (const item of list) {
					if (item.childs) {
						const found = item.childs.find(child => child.mId === targetId);
						if (found) return found;
					}
				}
				return null;
			},
			findChildByPath(list, targetId) {
				for (const item of list) {
					if (item.childs) {
						const found = item.childs.find(child => child.href === '/#' + targetId);
						if (found) return found;
					}
				}
				return null;
			},
			// 标签页名称：仅当路由配置了 meta.title 或 meta.titleKey 时才展示该标签
			getTabTitle(path, meta) {
				if (path === '/views/index/index' || path === '/') {
					return { titleKey: 'layout.home' };
				}
				const m = meta || {};
				if (m.title) return { title: m.title };
				if (m.titleKey) return { titleKey: m.titleKey };
				return null;
			},
			goTab(tab) {
				if (this.$route.path === tab.path) return;
				this.$router.push(tab.path).catch(() => {});
			},
			removeTab(tab) {
				const list = this.visitedTabs.filter(t => t.path !== tab.path);
				this.visitedTabs = list;
				if (this.$route.path === tab.path) {
					const next = list.length ? list[list.length - 1] : { path: '/views/index/index' };
					this.$router.push(next.path).catch(() => {});
				}
			},
			closeAllTabs() {
				this.visitedTabs = [];
				this.$router.push('/views/index/index').catch(() => {});
			},
			async getSystemInfo() {
				const { data } = await listSystemInfo({ page: 1, row: 1 });
				this.systemInfo.systemSimpleTitle = data[0].systemSimpleTitle;
				this.systemInfo.companyName = data[0].companyName;
				this.systemInfo.logoUrl = data[0].logoUrl;
			},
			async loadCommunity() {
				const { communitys } = await _loadCommunityInfo();
				this.communitys = communitys;

				const currentCommunity = getCurrentCommunity();
				if (currentCommunity && communitys && communitys.length > 0) {
					const exists = communitys.some(c => c.communityId === currentCommunity.communityId);
					if (!exists) {
						setCurrentCommunity(communitys[0]);
					}
				}

				this.curCommunityName = getCommunityName();
			},
			async _loadStoreInfo() {
				this.loading = true;
				try {
					const res = await getStoreInfo();
					deepCopy(res, this.storeInfo);
				} catch (error) {
					console.error('登录失败：', error);
				} finally {
					this.loading = false;
				}
			},
			async loadCatalogs() {
				this.loading = true;
				try {
					const res = await _getMenuCatalog();
					if (res.code != 0) {
						return;
					}
					this.catalogs = res.data;
					console.log(res.data, 'catalogs');

					if (this.catalogs && this.catalogs.length > 0) {
						this._changeMenuCatalog(this.catalogs[0]);
					}
				} catch (error) {
					console.error('登录失败：', error);
				} finally {
					this.loading = false;
				}
			},
			_changeMenuCatalog(_catalog, _isJump) {
				this.activeMenu = _catalog.caId;
				// console.log(_catalog, '_catalog');

				if (this._showModelDiv(_catalog)) {
					return;
				}
				if (_catalog.caId === '1') {
					this.$router.push('/#/pages/mall/product');
				}
				if (_catalog.url == 'IOT') {
					jumpToIot('/');
					return;
				}
				if (_catalog.url == 'MALL') {
					//获取用户名
					jumpToMall('/');
					return;
				}

				if (_catalog.url != '#' && _isJump) {
					this._gotoPage(_catalog.url, _catalog.name);
					//return;
				}

				this.loadMenuTree(_catalog);
			},

			handleCommand(command) {
				if (command === 'logout') {
					// 处理退出登录

					localStorage.removeItem('token');
					this.clearLocalStorage();
					this.$router.push('/login');
				} else if (command === 'zh' || command === 'en') {
					// 切换语言
					this.$i18n.locale = command;
					localStorage.setItem('language', command);
				}
			},
			clearLocalStorage() {
				const keepKeys = ['username', 'passwd', 'remember'];
				const isRemember = localStorage.getItem('remember');
				if (isRemember) {
					Object.keys(localStorage).forEach(key => {
						if (!keepKeys.includes(key)) {
							localStorage.removeItem(key);
						}
					});
				} else {
					localStorage.clear();
				}
			},
			changeCommunity(community) {
				if (community == 'moreCommunity') {
					this.$refs.moreCommunity.open();
					return;
				}
				setCurrentCommunity(community);
				this.$store.commit('asset/SET_COMMUNITY_ID', community.communityId);
				this.curCommunityName = getCommunityName();
				window.location.href = '/';
			},
			handleMenuSelect(index) {
				// 处理菜单选择
				this.$router.push({ name: index });
			},
			loadMenuTree(_catalog) {
				this.activeAsideMenu = null;
				getMenuTree(_catalog).then(res => {
					let _menus = res.data;
					_menus.sort(function (a, b) {
						return a.seq - b.seq;
					});
					this.menuTree = _menus;

					const routeItem = this.findChildByPath(this.menuTree, this.$route.path);
					if (routeItem) {
						this.activeAsideMenu = routeItem.mId || '0';
					}

					// if (_catalog.url === '/') {
					// 	this.activeAsideMenu = '';
					// 	return;
					// }

					// const item = this.findChildByUrl(this.menuTree, _catalog.url.split('?')[0]);
					// if (item) {
					// 	this.activeAsideMenu = item.mId;
					// }
				});
			},
			findChildByUrl(list, url) {
				for (const item of list) {
					if (item.childs) {
						const found = item.childs.find(child => child.href.includes(url));
						if (found) return found;
					}
				}
				return null;
			},
			switchMenu(_menu) {
				//设置菜单ID
				this.menuId = _menu.id;
				this.menuTree = this.refreshMenuActive(this.menuTree, _menu.id);
				this.subMenus = _menu.childs;
				// console.log(this.subMenus);
				this.curMenuName = _menu.name;

				if (!_menu.childs || _menu.childs.length < 1) {
					return;
				}
				//选中第一个
				this._gotoPage(_menu.childs[0].href, _menu.childs[0].name);
				//vc._fix_height()
			},
			refreshMenuActive(jsonArray, _id) {
				for (let menuIndex = 0; menuIndex < jsonArray.length; menuIndex++) {
					if (jsonArray[menuIndex].childs) {
						let _childs = jsonArray[menuIndex].childs;
						_childs.sort(function (_child, _newChild) {
							return _child.seq - _newChild.seq;
						});
						jsonArray[menuIndex].childs = _childs;
					}

					if (_id === jsonArray[menuIndex].id) {
						//如果当前本身是打开状态，说明 需要关闭
						jsonArray[menuIndex].active = true;
						continue;
					}
					jsonArray[menuIndex].active = false;
				}
				return jsonArray;
			},
			_setSelectedMenusChild(_href) {
				for (var menuIndex = 0; menuIndex < this.menuTree.length; menuIndex++) {
					if (this.menuTree[menuIndex].childs) {
						var _childs = this.menuTree[menuIndex].childs;
						for (var childIndex = 0; childIndex < _childs.length; childIndex++) {
							if (_href == _childs[childIndex].href) {
								this.menuTree[menuIndex].childs[childIndex].active = true;
							} else {
								this.menuTree[menuIndex].childs[childIndex].active = false;
							}
						}
					}
				}
				this.$forceUpdate();
			},
			_gotoPage(_href, _tabName) {
				console.log(_href, _tabName);
				// 子菜单默认选中
				this._setSelectedMenusChild(_href);
				if (_href.indexOf('.html') > -1) {
					window.open(_href, '_blank');
					return;
				}
				if (_href.indexOf('/#/') > -1) {
					_href = _href.replace('/#/', '/');
				}

				this.$router.push(_href).catch(err => {
					// 忽略重复导航错误
					if (err.name !== 'NavigationDuplicated') {
						throw err;
					}
				});
			},
			_showModelDiv: function (_catalog) {
				// console.log(_catalog);
				if (_catalog.url.startsWith('?')) {
					let _modelName = _catalog.url.substring(1, _catalog.url.length);
					this.$refs[_modelName].open();
					return true;
				}
				return false;
			},
			_toIndex() {
				location.href = '/';
			},
			_closeSubMenu() {
				this.subMenus = [];
				this.curMenuName = '';
			},
		},
	};
</script>

<style lang="scss" scoped>
	.app-wrapper {
		height: 100vh;
	}

	.app-header {
		// background-color: #1e2132;
		background: linear-gradient(90deg, #e3f5ff 0%, #eff5ff 42.31%, #ffffff 100%);
		color: #fff;
		padding: 0;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.header-left {
		display: flex;
		align-items: center;
	}

	.logo {
		width: 159px;
		height: 60px;
		line-height: 60px;
		font-weight: 600;
		font-size: 13px;
		color: #1c1c1c;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}

	.logo-img {
		margin-left: 24px;
		width: 59px;
		height: 32px;
	}

	.header-menu {
		border: none;
	}

	:deep(.header-menu) {
		border-bottom: none !important;

		.el-menu-item {
			display: flex;
			align-items: center;
		}
		.el-menu-item:hover {
			background: rgba($color: #000, $alpha: 0.05) !important;
		}
	}

	.header-menu-item {
		width: auto;
		padding: 1px 11px;
		border-radius: 3px;
		font-size: 11px;
		background-color: #fff;
		height: 21px !important;
		line-height: 21px;
		display: flex;
		align-items: center;
	}

	.header-menu-item-icon {
		font-size: 12px;
		margin-right: 3px;
		color: #1c1c1c;
	}

	.header-menu-item-active {
		background-color: #286bff;
	}

	.header-right {
		display: flex;
		align-items: center;
		margin-right: 20px;
		color: #1c1c1c;
	}

	.icon-right {
		color: #1c1c1c;
		margin-left: 10px;
		cursor: pointer;
		font-size: 16px;
	}

	.margin-left {
		margin-left: 15px;
		color: #1c1c1c;
	}

	.user-info {
		color: #1c1c1c;
		margin: 0 15px 0 7px;
		// cursor: pointer;
	}
	.icons {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 5px;
		border-radius: 5px;
		border: 1px solid rgba(28, 28, 28, 0.1);
		margin: 0 10px;
		cursor: pointer;
	}
	.app-aside {
		width: 159px;
		overflow: auto;
	}

	// .menu-wrapper {
	// 	height: 100%;
	// }

	// .el-menu-vertical {
	// 	border: none;
	// }

	// .el-menu-vertical:not(.el-menu--collapse) {
	// 	width: 200px;
	// }

	.app-main {
		background-color: #f5f7fa;
		height: calc(100vh - 60px);
		padding: 0px;
		/* 整个滚动条 */
		&::-webkit-scrollbar {
			width: 10px; /* 垂直滚动条宽度 */
			height: 10px; /* 横向滚动条高度 */
		}

		/* 滚动条轨道（背景） */
		&::-webkit-scrollbar-track {
			background: #e0e0e0;
			border-radius: 5px;
		}

		/* 滑块 */
		&::-webkit-scrollbar-thumb {
			background: #707070; /* 颜色 */
			border-radius: 5px; /* 圆角 */
			border: 2.5px solid #e0e0e0; /* 内边距效果 */
		}

		/* 滑块悬停效果 */
		&::-webkit-scrollbar-thumb:hover {
			background: #505050;
		}
	}

	.tabs-wrap {
		display: flex;
		align-items: center;
		padding: 8px 16px;
		background: #fff;
		border-bottom: 1px solid #ebeef5;
		gap: 8px;
	}
	.tabs-list {
		display: flex;
		flex-wrap: nowrap;
		gap: 4px;
		flex: 1;
		min-width: 0;
		overflow-x: auto;
	}
	.tabs-item {
		display: inline-flex;
		align-items: center;
		padding: 6px 12px;
		font-size: 13px;
		border-radius: 4px;
		cursor: pointer;
		color: #606266;
		background: #f4f4f5;
		max-width: 160px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.tabs-item:hover {
		color: #409eff;
		background: #ecf5ff;
	}
	.tabs-item.active {
		color: #409eff;
		background: #ecf5ff;
		font-weight: 500;
	}
	.tabs-item-title {
		flex: 1;
		min-width: 0;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.tabs-item-close {
		margin-left: 6px;
		font-size: 12px;
		opacity: 0.7;
	}
	.tabs-item-close:hover {
		opacity: 1;
		color: #f56c6c;
	}
	.tabs-close-all {
		flex-shrink: 0;
		padding: 4px 8px;
	}

	// :deep(.el-menu--horizontal) {
	// 	border-bottom: none;
	// }

	// :deep(.header-menu  .el-menu-item) {
	// 	height: 50px;
	// 	line-height: 50px;
	// }

	// :deep(.header-menu .el-submenu__title) {
	// 	height: 50px;
	// 	line-height: 50px;
	// 	padding: 0 20px !important;
	// }

	// :deep(.el-menu--collapse) {
	// 	width: 64px;
	// }

	// :deep(.el-menu--collapse .el-submenu__title) {
	// 	padding: 0 !important;
	// 	text-align: center;
	// }

	// :deep(.el-menu--collapse .el-submenu__title i) {
	// 	margin: 0;
	// 	font-size: 20px;
	// }

	// :deep(.el-menu--popup) {
	// 	min-width: 200px;
	// 	background-color: #1e2132 !important;
	// }

	// :deep(.el-menu--popup .el-menu-item) {
	// 	background-color: #1e2132;
	// 	color: #fff;
	// }

	// :deep(.el-menu--popup .el-menu-item:hover) {
	// 	background-color: #2a2f45;
	// }

	// :deep(.el-menu--popup .el-menu-item.is-active) {
	// 	color: #409eff;
	// }

	.vc-menu-main {
		width: auto;
		height: calc(100vh - 60px);
		overflow-y: scroll;
		text-align: left;
	}

	.vc-menu-main::-webkit-scrollbar {
		display: none;
	}
	:deep(.vc-menu-main) {
		.el-menu-item {
			width: 100% !important;
			padding-left: 0px !important;
			padding-right: 0px;
			display: flex;
			align-items: center;
		}
		.el-submenu {
			.el-submenu__title {
				padding-left: 12px !important;
				display: flex;
				align-items: center;
			}
		}
		.el-menu-item:hover {
			background: rgba($color: #000, $alpha: 0.05) !important;
		}
	}

	.menu-items {
		box-sizing: border-box;
		width: 100%;
		// height: 21px;
		text-align: left;
		border-radius: 3px;
		// line-height: 21px;
		padding-left: 34px;
	}

	.menu-items-active {
		background: rgba(25, 115, 245, 0.1) !important;
	}

	.home-menu {
		background: rgba(28, 28, 28, 0.05);
		position: relative;
	}

	.home-menu::before {
		content: '';
		border-radius: 3px;
		width: 3px;
		height: 70%;
		background: #1c1c1c;
		position: absolute;
		left: 0;
		top: 50%;
		transform: translateY(-50%);
	}

	.menu-group {
		font-size: 11px;
		color: rgba(28, 28, 28, 0.4);
		line-height: 15px;
		margin: 5px 0 5px 20px;
	}
	.menu-title {
		margin-left: 8px;
	}

	// .vc-menu {
	// 	width: 100%;
	// 	// border-right: 1px solid #efeff0;

	// 	ul {
	// 		padding-inline-start: 0px;
	// 		margin: 0;
	// 		padding: 0;
	// 	}

	// 	li {
	// 		margin: 0;
	// 		padding: 0;
	// 	}
	// }

	.moreCommunity {
		font-weight: 600;
		color: #212529;
		font-size: 12px;
	}

	// .vc-menu-main ul li {
	// 	height: 45px;
	// 	line-height: 45px;
	// 	cursor: pointer;
	// 	list-style-type: none;
	// }

	// .vc-menu-main ul li:hover {
	// 	background-color: #3e77fc;
	// 	color: #ffffff;
	// }

	// .vc-menu-main ul li.title {
	// 	color: #ffffff;
	// 	height: 60px;
	// 	font-size: 24px;
	// 	line-height: 60px;
	// }

	// .vc-menu-main ul li.title a {
	// 	text-decoration: none;
	// 	cursor: pointer;
	// 	color: #ffffff;
	// }

	.vc-menu-sub {
		background-color: #ffffff;
		color: #545761;
		text-align: start;
		width: 110px;
		font-size: 14px;
		height: calc(100vh - 60px);
		overflow-x: hidden;
		overflow-y: scroll;
		scrollbar-width: none;
	}

	.vc-menu-sub::-webkit-scrollbar {
		display: none;
	}

	.vc-menu-sub .active {
		background-color: #eaf0fe;
		color: #3e77fc;
	}

	.vc-menu-sub ul li {
		height: 40px;
		line-height: 40px;
		padding-left: 15px;
		cursor: pointer;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.vc-menu-sub ul li.title {
		color: #4f525c;
		height: 40px;
		font-size: 14px;
		line-height: 40px;
		text-align: center;
		padding-left: 0px;
		border-bottom: 1px solid #f2f2f3;
		margin-bottom: 10px;
	}

	.vc-menu-sub ul li:hover {
		background-color: #eaf0fe;
		color: #3e77fc;
	}

	.vc-menu-sub ul li.sub-footer {
		background-color: #f6f6f7;
		text-align: center;
		position: fixed;
		bottom: 0;
		width: 100px;
	}
</style>